/**
 * 全社共通の問い合わせ窓口情報。
 * 電話・メールの問い合わせ導線（お問い合わせページ・物件詳細・フッター）で共有する。
 */
export const CONTACT_INFO = {
  /** 表示用の電話番号 */
  phone: '03-6455-1021',
  /** tel: リンク用（ハイフンなし） */
  phoneHref: 'tel:0364551021',
  /** 受付時間 */
  hours: '平日 10:00 - 18:00',
  /** 表示用のメールアドレス */
  email: 'support@officemap.jp',
  /** mailto: リンク用 */
  emailHref: 'mailto:support@officemap.jp',
} as const
